export const iconFontAwesomeWeatherMeteor = (
	<i className="fa-solid fa-meteor"></i>
);
